// // src/components/ui/list/InfiniteListWithFetch.tsx
// 'use client';

// import React from 'react';
// import {
//   useInfiniteList,
//   type FetchParams,
//   type FetchResult,
//   type ResetKind,
// } from '@/hooks/useInfiniteList';

// type InfiniteListWithFetchProps<T> = {
//   fetchData: (params: FetchParams) => Promise<FetchResult<T>>;

//   renderItem: (item: T, index: number) => React.ReactNode;

//   getKey?: (item: T, index: number) => string | number;

//   resetKey?: unknown;

//   resetKind?: ResetKind;

//   className?: string;

//   loadingView?: React.ReactNode;

//   emptyView?: React.ReactNode;

//   errorView?: React.ReactNode;

//   renderSkeleton?: (index: number) => React.ReactNode;

//   skeletonMode?: 'matchLoadedOrPrev' | 'fixed';

//   skeletonBaseCount?: number;

//   skeletonInitialCount?: number;

//   bootingSkeletonModeMap?: Partial<Record<ResetKind, 'none' | 'prevCount' | 'initial'>>;

//   rootMargin?: string;

//   /** 每頁幾筆（第一次載入也是這個數） */
//   pageSize?: number;
// };

// function InfiniteListWithFetch<T>({
//   fetchData,
//   renderItem,
//   getKey,
//   resetKey,
//   resetKind = 'other',
//   className = '',
//   loadingView = <div className="text-center py-4 text-muted">載入中...</div>,
//   emptyView = <div className="text-center py-4 text-muted">找不到符合的資料</div>,
//   errorView = <div className="text-center py-4 text-danger">載入失敗，請稍後再試</div>,
//   renderSkeleton,
//   skeletonMode = 'matchLoadedOrPrev',
//   skeletonBaseCount = 5,
//   skeletonInitialCount = 5,
//   bootingSkeletonModeMap,
//   rootMargin = '0px',
//   pageSize = 10, // ⭐ 這裡預設 10 筆，如你需求
// }: InfiniteListWithFetchProps<T>) {
//   const { items, loading, error, booting, hasMore, sentinelRef, prevCount } = useInfiniteList<T>({
//     fetchData,
//     pageSize,
//     resetKey,
//     resetKind,
//     rootMargin,
//   });

//   // booting 時 skeleton 策略
//   const bootingMode =
//     bootingSkeletonModeMap?.[resetKind] ?? (resetKind === 'keyword' ? 'none' : 'prevCount');

//   const calcSkeletonCount = () => {
//     if (!renderSkeleton) return 0;

//     if (booting) {
//       if (bootingMode === 'none') return 0;
//       if (bootingMode === 'prevCount') return prevCount || skeletonInitialCount;
//       return skeletonInitialCount;
//     }

//     if (skeletonMode === 'fixed') return skeletonBaseCount;

//     if (items.length > 0) return items.length;
//     if (prevCount > 0) return prevCount;
//     return skeletonInitialCount;
//   };

//   const skeletonCount = calcSkeletonCount();
//   const shouldShowSkeleton = !!renderSkeleton && loading && skeletonCount > 0;
//   const shouldShowEmpty = !loading && !error && !booting && items.length === 0;

//   // 避免同一輪 render key 重複
//   const usedKeys = new Set<string>();

//   return (
//     <div className={className}>
//       {/* 已載入項目 */}
//       {items.map((item, index) => {
//         const baseKey = getKey ? getKey(item, index) : index;
//         let keyStr = String(baseKey);
//         if (usedKeys.has(keyStr)) {
//           keyStr = `${keyStr}-${index}`;
//         }
//         usedKeys.add(keyStr);

//         return <React.Fragment key={keyStr}>{renderItem(item, index)}</React.Fragment>;
//       })}

//       {/* Skeleton */}
//       {shouldShowSkeleton &&
//         Array.from({ length: skeletonCount }).map((_, i) => (
//           <div key={`sk-${i}`}>{renderSkeleton!(i)}</div>
//         ))}

//       {/* 若沒有 renderSkeleton，退回 loadingView */}
//       {loading && !renderSkeleton && loadingView}

//       {/* Sentinel：有資料、還有下一頁、沒錯誤時才出現 */}
//       {items.length > 0 && hasMore && !loading && !error && <div ref={sentinelRef} />}

//       {/* 空清單 */}
//       {shouldShowEmpty && emptyView}

//       {/* 錯誤 */}
//       {error && errorView}
//     </div>
//   );
// }

// export default InfiniteListWithFetch;

// // src/components/ui/list/InfiniteListWithFetch.tsx
// 'use client';

// import React from 'react';
// import {
//   useInfiniteList,
//   type FetchParams,
//   type FetchResult,
//   type ResetKind,
// } from '@/hooks/useInfiniteList';

// type InfiniteListWithFetchProps<T> = {
//   fetchData: (params: FetchParams) => Promise<FetchResult<T>>;
//   renderItem: (item: T, index: number) => React.ReactNode;
//   getKey?: (item: T, index: number) => string | number;

//   resetKey?: unknown;
//   resetKind?: ResetKind;

//   className?: string;

//   loadingView?: React.ReactNode;
//   emptyView?: React.ReactNode;
//   errorView?: React.ReactNode;

//   renderSkeleton?: (index: number) => React.ReactNode;

//   skeletonMode?: 'matchLoadedOrPrev' | 'fixed';
//   skeletonBaseCount?: number;
//   skeletonInitialCount?: number;

//   bootingSkeletonModeMap?: Partial<Record<ResetKind, 'none' | 'prevCount' | 'initial'>>;

//   rootMargin?: string;
//   pageSize?: number;

//   sentinelMinHeightPx?: number;
// };

// function InfiniteListWithFetch<T>({
//   fetchData,
//   renderItem,
//   getKey,
//   resetKey,
//   resetKind = 'other',
//   className = '',
//   loadingView = <div className="text-center py-4 text-muted">載入中...</div>,
//   emptyView = <div className="text-center py-4 text-muted">找不到符合的資料</div>,
//   errorView = <div className="text-center py-4 text-danger">載入失敗，請稍後再試</div>,
//   renderSkeleton,
//   skeletonMode = 'matchLoadedOrPrev',
//   skeletonBaseCount = 5,
//   skeletonInitialCount = 5,
//   bootingSkeletonModeMap,
//   rootMargin = '0px',
//   pageSize = 10,
//   sentinelMinHeightPx = 1,
// }: InfiniteListWithFetchProps<T>) {
//   const { items, loading, error, booting, hasMore, sentinelRef, prevCount } = useInfiniteList<T>({
//     fetchData,
//     pageSize,
//     resetKey,
//     resetKind,
//     rootMargin,
//     getKey, // ✅ 讓 hook 層做全域去重（根因修正）
//   });

//   const bootingMode =
//     bootingSkeletonModeMap?.[resetKind] ?? (resetKind === 'keyword' ? 'none' : 'prevCount');

//   const calcSkeletonCount = () => {
//     if (!renderSkeleton) return 0;

//     if (booting) {
//       if (bootingMode === 'none') return 0;
//       if (bootingMode === 'prevCount') return prevCount || skeletonInitialCount;
//       return skeletonInitialCount;
//     }

//     if (loading && items.length > 0) {
//       return skeletonBaseCount;
//     }

//     if (skeletonMode === 'fixed') return skeletonBaseCount;

//     if (items.length > 0) return Math.min(items.length, skeletonBaseCount);
//     if (prevCount > 0) return Math.min(prevCount, skeletonBaseCount);
//     return skeletonInitialCount;
//   };

//   const skeletonCount = calcSkeletonCount();
//   const shouldShowSkeleton = !!renderSkeleton && loading && skeletonCount > 0;
//   const shouldShowEmpty = !loading && !error && !booting && items.length === 0;

//   // ✅ 最後一道保險：同一輪 render 也不要渲染重複 key
//   const usedKeys = new Set<string>();

//   return (
//     <div className={className}>
//       {items.map((item, index) => {
//         const baseKey = getKey ? getKey(item, index) : index;
//         const keyStr = String(baseKey).trim();

//         if (keyStr && usedKeys.has(keyStr)) {
//           return null; // ✅ 直接不渲染重複項
//         }
//         if (keyStr) usedKeys.add(keyStr);

//         return (
//           <React.Fragment key={keyStr || String(index)}>{renderItem(item, index)}</React.Fragment>
//         );
//       })}

//       {shouldShowSkeleton &&
//         Array.from({ length: skeletonCount }).map((_, i) => (
//           <div key={`sk-${i}`}>{renderSkeleton!(i)}</div>
//         ))}

//       {loading && !renderSkeleton && loadingView}

//       {items.length > 0 && hasMore && !loading && !error && (
//         <div
//           ref={sentinelRef}
//           aria-hidden="true"
//           data-sentinel="infinite-list"
//           style={{ height: `${sentinelMinHeightPx}px`, width: '1px' }}
//         />
//       )}

//       {shouldShowEmpty && emptyView}
//       {error && errorView}
//     </div>
//   );
// }

// export default InfiniteListWithFetch;

// src/components/ui/list/InfiniteListWithFetch.tsx
'use client';

import React from 'react';
import {
  useInfiniteList,
  type FetchParams,
  type FetchResult,
  type ResetKind,
} from '@/hooks/useInfiniteList';

type InfiniteListWithFetchProps<T> = {
  fetchData: (params: FetchParams) => Promise<FetchResult<T>>;
  renderItem: (item: T, index: number) => React.ReactNode;
  getKey?: (item: T, index: number) => string | number;

  resetKey?: unknown;
  resetKind?: ResetKind;

  className?: string;

  loadingView?: React.ReactNode;
  emptyView?: React.ReactNode;
  errorView?: React.ReactNode;

  renderSkeleton?: (index: number) => React.ReactNode;

  skeletonMode?: 'matchLoadedOrPrev' | 'fixed';
  skeletonBaseCount?: number;
  skeletonInitialCount?: number;

  bootingSkeletonModeMap?: Partial<Record<ResetKind, 'none' | 'prevCount' | 'initial'>>;

  rootMargin?: string;
  pageSize?: number;

  sentinelMinHeightPx?: number;

  /** ✅ load more 時：至少有幾筆才顯示 skeleton（避免 1~2 筆一直閃） */
  skeletonMinItemsToShow?: number;

  /** ✅ 到底提示 */
  endView?: React.ReactNode;

  /** ✅ 至少幾筆後才顯示「已經到底囉～」（你要 4） */
  endMinItemsToShow?: number;
};

function InfiniteListWithFetch<T>({
  fetchData,
  renderItem,
  getKey,
  resetKey,
  resetKind = 'other',
  className = '',
  loadingView = <div className="text-center py-4 text-muted">載入中...</div>,
  emptyView = <div className="text-center py-4 text-muted">找不到符合的資料</div>,
  errorView = <div className="text-center py-4 text-danger">載入失敗，請稍後再試</div>,
  renderSkeleton,
  skeletonMode = 'matchLoadedOrPrev',
  skeletonBaseCount = 5,
  skeletonInitialCount = 5,
  bootingSkeletonModeMap,
  rootMargin = '0px',
  pageSize = 10,
  sentinelMinHeightPx = 1,
  skeletonMinItemsToShow = 5,

  endView = <div className="text-center py-4 text-grey w-100">已經到底囉～</div>,
  endMinItemsToShow = 4,
}: InfiniteListWithFetchProps<T>) {
  const { items, loading, error, booting, hasMore, sentinelRef, prevCount } = useInfiniteList<T>({
    fetchData,
    pageSize,
    resetKey,
    resetKind,
    rootMargin,
    getKey, // ✅ 讓 hook 層做全域去重（根因修正）
  });

  const bootingMode =
    bootingSkeletonModeMap?.[resetKind] ?? (resetKind === 'keyword' ? 'none' : 'prevCount');

  const calcSkeletonCount = () => {
    if (!renderSkeleton) return 0;

    if (booting) {
      if (bootingMode === 'none') return 0;
      if (bootingMode === 'prevCount') return prevCount || skeletonInitialCount;
      return skeletonInitialCount;
    }

    // ✅ load more：items 太少就不顯示 skeleton，避免閃爍很怪
    if (loading && items.length > 0) {
      if (items.length < skeletonMinItemsToShow) return 0;
      return skeletonBaseCount;
    }

    if (skeletonMode === 'fixed') return skeletonBaseCount;

    if (items.length > 0) return Math.min(items.length, skeletonBaseCount);
    if (prevCount > 0) return Math.min(prevCount, skeletonBaseCount);
    return skeletonInitialCount;
  };

  const skeletonCount = calcSkeletonCount();
  const shouldShowSkeleton = !!renderSkeleton && loading && skeletonCount > 0;
  const shouldShowEmpty = !loading && !error && !booting && items.length === 0;

  // ✅ 到底提示：不在 loading / booting / error，且 hasMore=false，且 items >= 4 才顯示
  const shouldShowEnd =
    !booting && !loading && !error && !hasMore && items.length >= endMinItemsToShow;

  // ✅ 最後一道保險：同一輪 render 也不要渲染重複 key
  const usedKeys = new Set<string>();

  return (
    <div className={className}>
      {items.map((item, index) => {
        const baseKey = getKey ? getKey(item, index) : index;
        const keyStr = String(baseKey).trim();

        if (keyStr && usedKeys.has(keyStr)) return null;
        if (keyStr) usedKeys.add(keyStr);

        return (
          <React.Fragment key={keyStr || String(index)}>{renderItem(item, index)}</React.Fragment>
        );
      })}

      {shouldShowSkeleton &&
        Array.from({ length: skeletonCount }).map((_, i) => (
          <div key={`sk-${i}`}>{renderSkeleton!(i)}</div>
        ))}

      {loading && !renderSkeleton && loadingView}

      {items.length > 0 && hasMore && !loading && !error && (
        <div
          ref={sentinelRef}
          aria-hidden="true"
          data-sentinel="infinite-list"
          style={{ height: `${sentinelMinHeightPx}px`, width: '1px' }}
        />
      )}

      {shouldShowEmpty && emptyView}
      {error && errorView}

      {shouldShowEnd && endView}
    </div>
  );
}

export default InfiniteListWithFetch;
